import React, { useState, useEffect } from 'react';
import api from '../services/api';
const CategoriePlanModal = ({ isOpen, onClose, onSuccess, monteurs, defaultDate }) => {
  const [categorieen, setCategorieen] = useState([]);
  const [categorieId, setCategorieId] = useState('');
  const [datum, setDatum] = useState('');
  const [aantalUren, setAantalUren] = useState('1.0');
  const [geselecteerdeMonteurs, setGeselecteerdeMonteurs] = useState([]);
  const [ordernummer, setOrdernummer] = useState('');
  const [opmerking, setOpmerking] = useState('');
  const [bezig, setBezig] = useState(false);
  const [foutmelding, setFoutmelding] = useState('');

  useEffect(() => {
    if (isOpen) {
      // Reset form
      setFoutmelding('');
      setOrdernummer('');
      setOpmerking('');
      setGeselecteerdeMonteurs([]);
      setAantalUren('1.0');
      const standaard = defaultDate
        ? new Date(defaultDate).toISOString().split('T')[0]
        : new Date().toISOString().split('T')[0];
      setDatum(standaard);

      // Laad categorieen
      api.get('/plan-categorieen')
        .then(res => {
          const actieve = (res.data.data || []).filter(c => c.actief !== false);
          setCategorieen(actieve);
          if (actieve.length > 0 && !categorieId) {
            setCategorieId(String(actieve[0].id));
          }
        })
        .catch(err => {
          console.error('Fout laden categorieen:', err);
          setFoutmelding('Kon categorieen niet laden');
        });
    }
    // eslint-disable-next-line
  }, [isOpen, defaultDate]);


  const toggleMonteur = (id) => {
    setGeselecteerdeMonteurs(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const allesSelecteren = () => {
    if (geselecteerdeMonteurs.length === monteurs.length) {
      setGeselecteerdeMonteurs([]);
    } else {
      setGeselecteerdeMonteurs(monteurs.map(m => m.id));
    }
  };

  const submit = async () => {
    setFoutmelding('');
    if (!categorieId || !datum || !aantalUren || geselecteerdeMonteurs.length === 0) {
      setFoutmelding('Vul categorie, datum, uren en minimaal 1 monteur in');
      return;
    }
    setBezig(true);
    try {
      const res = await api.post('/categorie-planning', {
        categorie_id: parseInt(categorieId, 10),
        gebruiker_ids: geselecteerdeMonteurs,
        gepland_op: datum,
        aantal_uren: parseFloat(aantalUren),
        ordernummer: ordernummer || null,
        opmerking: opmerking || null
      });
      if (res.data.success) {
        if (onSuccess) onSuccess(res.data.count);
        onClose();
      } else {
        setFoutmelding(res.data.message || 'Onbekende fout');
      }
    } catch (err) {
      console.error(err);
      setFoutmelding(err.response?.data?.message || err.message);
    } finally {
      setBezig(false);
    }
  };

  const huidigeCategorie = categorieen.find(c => String(c.id) === String(categorieId));

  // Als gekozen categorie defaults heeft, vul die in (alleen als velden nog leeg zijn of nog default-waarde)
  useEffect(() => {
    if (!huidigeCategorie) return;
    if (huidigeCategorie.default_uren != null && (aantalUren === '' || aantalUren === '1.0')) {
      setAantalUren(String(huidigeCategorie.default_uren));
    }
    if (huidigeCategorie.default_ordernummer && !ordernummer) {
      setOrdernummer(huidigeCategorie.default_ordernummer);
    }
    // eslint-disable-next-line
  }, [categorieId]);


  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }} onClick={onClose}>
      <div style={{
        background: 'white', borderRadius: 12, padding: 24,
        width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
      }} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: '0 0 16px', fontSize: 20, color: '#1e293b' }}>
          📅 Extra inplannen
        </h2>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 4, color: '#374151' }}>
            Categorie *
          </label>
          <select
            value={categorieId}
            onChange={e => setCategorieId(e.target.value)}
            style={{
              width: '100%', padding: '10px 12px',
              border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14
            }}>
            <option value="">— Kies categorie —</option>
            {categorieen.map(c => (
              <option key={c.id} value={c.id}>
                {c.titel} ({c.sap_code})
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 4, color: '#374151' }}>
              Datum *
            </label>
            <input
              type="date"
              value={datum}
              onChange={e => setDatum(e.target.value)}
              style={{
                width: '100%', padding: '10px 12px',
                border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box'
              }} />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 4, color: '#374151' }}>
              Aantal uren *
            </label>
            <input
              type="number"
              step="0.5"
              min="0.5"
              max="24"
              value={aantalUren}
              onChange={e => setAantalUren(e.target.value)}
              style={{
                width: '100%', padding: '10px 12px',
                border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box'
              }} />
          </div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
            <label style={{ fontSize: 13, fontWeight: 500, color: '#374151' }}>
              Voor wie? * ({geselecteerdeMonteurs.length} geselecteerd)
            </label>
            <button
              type="button"
              onClick={allesSelecteren}
              style={{
                background: 'none', border: 'none', color: '#2563eb',
                fontSize: 12, cursor: 'pointer', padding: 0
              }}>
              {geselecteerdeMonteurs.length === monteurs.length ? 'Niemand' : 'Allemaal'}
            </button>
          </div>
          <div style={{
            border: '1px solid #d1d5db', borderRadius: 8,
            maxHeight: 180, overflowY: 'auto', padding: 8, background: '#f9fafb'
          }}>
            {monteurs.length === 0 && (
              <div style={{ fontSize: 13, color: '#9ca3af', padding: 8 }}>
                Geen monteurs gevonden
              </div>
            )}
            {monteurs.map(m => (
              <label key={m.id} style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '6px 8px', cursor: 'pointer',
                borderRadius: 4, fontSize: 14
              }}>
                <input
                  type="checkbox"
                  checked={geselecteerdeMonteurs.includes(m.id)}
                  onChange={() => toggleMonteur(m.id)}
                />
                {m.voornaam} {m.achternaam}
                {m.rol && <span style={{ fontSize: 11, color: '#6b7280' }}>({m.rol})</span>}
              </label>
            ))}
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 4, color: '#374151' }}>
              Ordernummer (optioneel)
            </label>
            <input
              type="text"
              value={ordernummer}
              onChange={e => setOrdernummer(e.target.value)}
              placeholder="Bijv. 50530370"
              style={{
                width: '100%', padding: '10px 12px',
                border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box'
              }} />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 4, color: '#374151' }}>
              Opmerking (optioneel)
            </label>
            <input
              type="text"
              value={opmerking}
              onChange={e => setOpmerking(e.target.value)}
              placeholder="Korte notitie"
              style={{
                width: '100%', padding: '10px 12px',
                border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box'
              }} />
          </div>
        </div>

        {huidigeCategorie && geselecteerdeMonteurs.length > 0 && (
          <div style={{
            padding: '10px 14px', background: '#eff6ff',
            border: '1px solid #93c5fd', borderRadius: 8,
            fontSize: 13, color: '#1e40af', marginBottom: 14
          }}>
            ℹ️ Maakt {geselecteerdeMonteurs.length} planning-{geselecteerdeMonteurs.length === 1 ? 'item' : 'items'} aan
            voor <strong>{huidigeCategorie.titel}</strong> (SAP code {huidigeCategorie.sap_code}),
            elk {aantalUren} uur op {datum}.
          </div>
        )}

        {foutmelding && (
          <div style={{
            padding: '10px 14px', background: '#fef2f2',
            border: '1px solid #fecaca', borderRadius: 8,
            fontSize: 13, color: '#dc2626', marginBottom: 14
          }}>
            ❌ {foutmelding}
          </div>
        )}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            disabled={bezig}
            style={{
              padding: '10px 20px', background: '#f3f4f6',
              border: '1px solid #d1d5db', borderRadius: 8,
              cursor: 'pointer', fontWeight: 500, fontSize: 14
            }}>
            Annuleren
          </button>
          <button
            onClick={submit}
            disabled={bezig || !categorieId || !datum || geselecteerdeMonteurs.length === 0}
            style={{
              padding: '10px 20px', background: bezig ? '#94a3b8' : '#2563eb',
              color: 'white', border: 'none', borderRadius: 8,
              cursor: bezig ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: 14
            }}>
            {bezig ? 'Bezig...' : `Plannen voor ${geselecteerdeMonteurs.length} ${geselecteerdeMonteurs.length === 1 ? 'persoon' : 'personen'}`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoriePlanModal;
